import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Unit 10',
    id: 'WB3-U10-P68-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    padding: 0,
    textAlign: 'center',
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page68/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page68/E1/1.jpg' },
      ],
      [
        // Column2 wedding
        { url: 'img/FriendsPlus/Page68/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page68/E1/3.jpg', input: true, answer: "w" },
        { url: 'img/FriendsPlus/Page68/E1/4.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page68/E1/5.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page68/E1/6.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page68/E1/7.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page68/E1/8.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page68/E1/9.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page68/E1/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page68/E1/11.jpg' },
      ],
      [
        // Column4 bride
        { url: 'img/FriendsPlus/Page68/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page68/E1/13.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page68/E1/14.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page68/E1/15.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page68/E1/16.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page68/E1/17.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page68/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page68/E1/19.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page68/E1/20.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page68/E1/21.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page68/E1/22.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page68/E1/23.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page68/E1/24.jpg' },
      ],
    ]
  },
  2: {
    unit: 'Unit 10',
    id: 'WB3-U10-P68-E2',
    audio: 'img/FriendsPlus/Page68/Audio/audio-e2-p68.mp3',
    video: '',
    component: DesignUnderLine,
    titleImage: '',
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page68/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page68/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page68/Audio/tieude-e2-p68.mp3' },
        { url: 'img/FriendsPlus/Page68/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page68/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page68/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page68/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/8.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page68/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/10.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page68/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page68/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page68/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/14.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page68/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/16.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page68/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/18.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page68/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/20.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page68/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/22.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page68/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page68/E2/24.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page68/E2/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page68/E2/26.jpg' },
      ],

    ]
  },
  3: {
    unit: 'Unit 9',
    id: 'WB3-U9-P65-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page65/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page65/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page65/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page65/E3/18.jpg' },
      ],
    ]
  },



}
export default json;